module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_footer_aqua-410de04315033c0f897c9eb9bbdfd413.svg";